var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapDoteOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 70,
    viewBox: "0 0 50 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M46 23C46 9.806 34.89-.793 21.515.047 10.357.747 1.16 9.63.106 20.76c-1.125 11.899 6.827 22.124 17.73 24.627a5.49 5.49 0 013.607 2.77c.676 1.262 1.201 2.68 1.43 3.598a.13.13 0 00.253 0c.23-.918.755-2.336 1.431-3.597a5.504 5.504 0 013.618-2.773C38.382 43.036 46 33.92 46 23"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    width: "139.1%",
    height: "134.7%",
    x: "-13%",
    y: "-13.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 1.7,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "blur",
    dx: 3,
    dy: 3,
    result: "offsetBlur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff931e",
    floodOpacity: 0.5,
    result: "offsetColor"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "offsetColor",
    in2: "offsetBlur",
    operator: "in",
    result: "offsetBlur"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    d: "M28.798 61.99a5.798 5.798 0 11-11.596 0 5.798 5.798 0 0111.596 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.108 3.073)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "outer-dot",
    width: "",
    styles: "[object Object]"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff931e",
    stroke: "#ff931e",
    color: "black",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }, /*#__PURE__*/React.createElement("text", {
    x: "41%",
    y: "35%",
    alignmentBaseline: "middle",
    textAnchor: "middle",
    fill: "white",
    fontSize: 12,
    className: "marker-text"
  }, "14")), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ff931e",
    d: "M25.899 61.99a2.9 2.9 0 11-5.798 0 2.9 2.9 0 015.798 0",
    color: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDoteOrange);
export default __webpack_public_path__ + "static/media/MapDote-orange.35a573c348faafa3ba44c07092c27a5e.svg";
export { ForwardRef as ReactComponent };